// react
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";

// third-party
import { Helmet } from "react-helmet-async";

// data stubs
import theme from "../../data/theme";
import shopApi from "../../api/shop";
import { toast } from "react-toastify";

export default function AccountPageResetPassword(props) {
    const { token } = props;

    const [password, setPassword] = useState();
    const [confirmPassword, setConfirmPassword] = useState();

    const handleChangePassword = (e) => {
        setPassword(e.target.value);
    };
    const handleChangeConfirmPassword = (e) => {
        setConfirmPassword(e.target.value);
    };

    const handleSubmit = () => {
        if (password === confirmPassword) {
            shopApi.newPassword(token, password).then((response) => {
                setPassword("");
                setConfirmPassword("");
                toast.success("Votre de mot de passe a été changer avec succes.", {
                    theme: "colored",
                    autoClose: 20000,
                });
            }); 
        }else{
            toast.error("mot de passe diferrent.", {
                theme: "colored",
                autoClose: 20000,
            });
        }
    };

    return (
        <div className="container mt-4 mb-4">
            <div className="card">
                <Helmet>
                    <title>{`Change Password — ${theme.name}`}</title>
                </Helmet>

                <div className="card-header">
                    <h5><FormattedMessage id="Account.changePassword" defaultMessage="Change Password" /></h5>
                </div>
                <div className="card-divider" />
                <div className="card-body">
                    <div className="row no-gutters">
                        <div className="col-12 col-lg-7 col-xl-6">
                            <div className="form-group">
                                <label htmlFor="password-new"><FormattedMessage id="Account.newPassword" defaultMessage="New Password" /></label>
                                <input
                                    type="password"
                                    className="form-control"
                                    onChange={handleChangePassword}
                                    value={password}
                                    id="password-new"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="password-confirm"><FormattedMessage id="Account.confirmPassword" defaultMessage="Confirm Password" /></label>
                                <input
                                    type="password"
                                    className="form-control"
                                    onChange={handleChangeConfirmPassword}
                                    value={confirmPassword}
                                    id="password-confirm"
                                />
                            </div>

                            <div className="form-group mt-5 mb-0">
                                <button type="button" onClick={handleSubmit} className="btn btn-primary">
                                    <FormattedMessage id="Account.changePassword" defaultMessage="Change Password" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
